import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import * as locales from 'locales';

import config from './config';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: config.DEFAULT_LOCALE,
    supportedLngs: config.LOCALES,
    debug: !config.IS_PRODUCTION,
    detection: {
      lookupQuerystring: 'locale',
      lookupCookie: 'locale',
      lookupLocalStorage: 'locale',
      lookupSessionStorage: 'locale',
    },
    interpolation: {
      escapeValue: false,
    },
    resources: { ...locales },
  });

export default i18next;
